
const IconBoxFlex = (props) => {
    return (
        <div className="icon_box_flex">
            <div className="icon_size">
                <img src={props.img} alt="Icon" />
            </div>
            <h3 >{props.text}</h3>
        </div>
    );
};

export default IconBoxFlex;